export const SHOWLOGIN      = "AuthSlice/showLoginModal";
export const SHOWREGISTER   = "AuthSlice/showRegisterModal";